import Header from '../components/Header';
import Footer from '../components/Footer';
import GlobalIcons from '../components/GlobalIcons';

const AppShell = ({
    children,
    showHeader = false,
    showFooter = false,
    currentRoute = null,
    headerProps = {},
    footerProps = {}
}) => {
    return (
        <div className="app-shell">
            <Header show={showHeader} route={currentRoute} routeKey={currentRoute?.key || ''} {...headerProps} />

            <div className="app-shell__body">
                {children}
            </div>

            <Footer show={showFooter} {...footerProps} />

            <GlobalIcons route={currentRoute} />
        </div>
    );
};

export default AppShell;
